import { Component, OnInit, ViewEncapsulation, TemplateRef, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { title } from 'process';

// import { SelectionModel } from '@angular/cdk/collections/selection-model';
// import { FlatTreeControl } from '@angular/cdk/tree/control/flat-tree-control';
import { Injectable } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { PhysicalYear, HalfYear, Quarter, Month, Week } from 'src/models/facebook-method-forecast';
import { ConfigurationService } from 'src/services/configuration.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';


/**
 * Node for to-do item
 */
export class FoodNode {
  children?: FoodNode[];
  item: string;
}

/** Flat to-do item node with expandable and level information */
export class FoodFlatNode {
  item: string;
  level: number;
  expandable: boolean;
}

/**
 * The Json object for to-do list data.
 */
const TREE_DATA: FoodNode[] = [
  {
    item: "Virtual Reality",
    children: [
      {
        item: 'Oculus',
        children: [
          {
            item: "Oculus Hardware",
            children: [
              {
                item: "Quest",
                children: [
                  { item: 'Quest 2 64GB' },
                  { item: 'Quest 2 256GB' }
                ]
              }
            ]
          },
          {
            item: 'Oculus Accessories'
          }
        ]
      },
    ]
  },
  {
    item: 'Video Calling',
    children: [
      { item: 'Portal' }
    ]
  }
];

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable({ providedIn: "root" })
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<FoodNode[]>([]);
  treeData: any[];

  get data(): FoodNode[] {
    return this.dataChange.value;
  }

  constructor() {
    this.initialize();
  }

  initialize() {
    this.treeData = TREE_DATA;
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    const data = TREE_DATA;

    // Notify the change.
    this.dataChange.next(data);
  }

  public filter(filterText: string) {
    let filteredTreeData;
    if (filterText) {
      // Filter the tree
      function filter(array, text) {
        const getChildren = (result, object) => {
          if (object.item.toLowerCase() === text.toLowerCase()) {
            result.push(object);
            return result;
          }
          if (Array.isArray(object.children)) {
            const children = object.children.reduce(getChildren, []);
            if (children.length) result.push({ ...object, children });
          }
          return result;
        };

        return array.reduce(getChildren, []);
      }

      filteredTreeData = filter(this.treeData, filterText);
    } else {
      // Return the initial tree
      filteredTreeData = this.treeData;
    }

    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    // file node as children.
    const data = filteredTreeData;
    // Notify the change.
    this.dataChange.next(data);
  }
}

@Component({
  selector: 'app-facebook-method-forecast',
  templateUrl: './facebook-method-forecast.component.html',
  styleUrls: ['./facebook-method-forecast.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ChecklistDatabase]
})
export class FacebookMethodForecastComponent implements OnInit {
  methodList = [
    {name: 'Linear', key: 'Linear'},
    {name: 'Curve', key: 'Curve'},
    {name: 'Exponential', key:'Exponential'},
    {name: 'Logarithmic', key: 'Logarithmic'},
    {name: 'Power', key:'Power'},
    {name: 'Parabola', key: 'Parabola'},
    {name: 'Moving Average', key: 'MovingAverage'},
    {name: 'Single Expotential Smoothing', key: 'SingleExpotentialSmoothing'},
    {name: 'Adaptive Smoothing', key: 'Adaptive Smoothing'},
    {name: 'Holts Linear Trend', key: 'HoltsLinearTrend'},
    {name: 'Period Percentage Change', key: 'PeriodPercentageChange'},
    {name: 'Seasonal Smoothing Method', key: 'SeasonalSmoothingMethod'},
    {name: 'Seasonal Smoothing Average', key: 'SeasonalSmoothingAverage'},
    {name: 'Seasonal Percentage Change', key: 'SeasonalPercentageChange'},
    {name: 'Additive Decomposition', key: 'AdditiveDecomposition'},
    {name: 'Winters Additive', key: 'WintersAdditive'},
    {name: 'Current Algo Baseline ST Forecast', key: 'CurrentAlgoBaselineSTForecast'}
  ];
  width = '100%';
  height = '500';
  type = "msline";
  dataFormat = "json";
  dataSource;
  public submitted = false;
  public isEdit = false;
  public columnDefs = [];
  private gridApi: any;
  dropdownSettings = {};
  dropdownSettingsSingle = {};
  public tenureTypeList = [];
  public tenureTypeListTemp = [];
  public rowList = [];
  public goalTypeList = [];
  public gridOptions: any;
  public getRowHeight;
  public getRowStyle;
  public headerHeight;
  public modules = AllCommunityModules;
  public clientId = 1;
  public channelList = [
    { item_id: 'Direct', item_text: 'Direct' },
    { item_id: 'Distributor', item_text: 'Distributor' },
    { item_id: 'DTC', item_text: 'DTC' }
  ];
  public channel = null;
  public csvRecords: any;
  public customerSelectedList = [];
  public selectedItemIds = [];
  public itemIdList = ['FB000038',
    'FB000084',
    'FB000063'];
  public customerList = [
    'Amazon AU',
    'Amazon CA',
    'Amazon JPN',
    'Amazon US',
    'Best Buy CA',
    'Best Buy US',
    'Synnex CA',
    'Synnex US',
    'WMT'

  ];
  public timeframeSelectedList = [];
  public itemSeletedList = [];
  public timeframeList = [];
  public versionList = [];
  public monthList = [];
  public itemList = [
    'Quest 64GB - US/CA/JP/TW',
    'Quest 128GB - US/CA/JP/TW',
    'Portal+ Black',
    'Oculus Go Relaxed Facial Interface',
    'Oculus Go Charging Cable',
    'Oculus Rift S Headband',
    'Oculus Rift Headset (only)',
    'Oculus Rift S',
    'Audio Arms',
    'Oculus Touch - Left Controller',
    'Oculus Quest UK/IE/HK/SG 64GB',
    'Rock Band VR connector',
    'Earphones',
    'Quest 64GB - EU',
    'Portal Black',
    'Quest 64GB - UK/IE/HK/SG',
    'Oculus Go Controller (Grade B)',
    'Portal Black (Gen 2)',
    'Touch',
    'Portal TV (Catalina)',
    'Oculus Rift S Standard Facial Interface',
    'Portal Mini - Dark (CA)',
    'Portal Dark - (CA)',
    'Oculus Go Carry Case',
    'Portal TV (UK/IE)',
    'Oculus Go Standalone VR 32 GB',
    'Portal+ White',
    'Rift - Marvel Bundle',
    'Unknown Oculus Product',
    'Portal Mini - White',
    'Portal Light - (CA)',
    'Oculus Go - 64GB',
    'Quest 64GB - AU/NZ',
    'Oculus Quest 128GB',
    'Sensor',
    'Quest 128GB and Case Bundle (S10252627@AMA+S10260629)',
    'Portal + White - CA',
    'Quest 128GB - AU/NZ',
    'Portal White - CA',
    'Oculus Go Controller',
    'Portal Mini (Omni)',
    'Portal White',
    'Portal White (Gen 2)',
    'Portal Mini - Black',
    'Oculus Quest IEM',
    'Portal Mini - Dark (EU)',
    'Oculus Quest Travel case',
    'Portal (Atlas)',
    'Oculus Quest UK/IE/HK/SG 128GB',
    'Portal+ Dark - (EU)',
    'Portal Mini - White (CA)',
    'Quest 64GB and Case Bundle (S10252626@AMA+S10260629)',
    'Portal TV (CA)',
    'Oculus Go - 32GB',
    'Oculus Go 64GB Headset (Grade B)',
    'Rift S',
    'Rift S Device',
    'Oculus Rift',
    '15W USB-C Power Adapter for the United Kingdom, Ireland, Hong Kong and Singapore',
    'SID (Simple Input Device)',
    '15W USB-C Power Adapter for EU',
    'Quest 128GB -EU',
    'HMD cable',
    'Oculus Go - 32GB ROW',
    'Online Game Code',
    'Oculus Touch - Right Controller',
    'Hardbundle',
    'Oculus Go Facial Interface Eye Rings',
    'Portal Mini - White (EU)',
    'Portal+ Light - (EU)',
    'Oculus Quest 64GB',
    'Oculus Go - 64GB ROW',
    'Oculus Touch Right Hand Controller',
    '15W USB-C Power Adapter for USA, Canada, Japan and Taiwan',
    'Portal TV (EU)',
    'Portal TV',
    'Portal Dark - (UK/IE)',
    'Portal + Black - CA',
    'Quest 128GB - UK/IE/HK/SG',
    'Oculus Go - Carrying Case',
    'Oculus Go Fitted Facial Interface',
    'Portal+ Light - (UK/IE)',
    'Oculus Sensor',
    'Oculus Go Controller Lanyard',
    'Portal+ Dark - (UK/IE)"',
    'Quest In-ear Headphones',
    'Portal Dark - (EU)',
    '15W USB-C Power Adapter for Australia and New Zealand',
    'Oculus Go Glasses Spacer',
    'Oculus Go Power Adapter',
    'Portal Light - (UK/IE)',
    'Oculus Go 32GB Headset (Grade B)',
    'Quest Travel Case',
    'Oculus Quest Standard Facial Interface',
    'Portal Light - (EU)',
    'Rift',
    'Portal Black - CA',
    'Portal Mini - White (UK/IE)',
    'Oculus Go Standalone VR 64 GB',
    'Portal Mini - Dark (UK/IE)',
    'Oculus Touch Left Hand Controller'
  ];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredCustomers: Observable<any[]>;
  filteredItems: Observable<any[]>;
  filteredTimeframe: Observable<any[]>;
  public seletedYear = null;
  public seletedVersion = null;
  public selectedMonth = null;
  public defaultRow = {};
  public selectAll = true;
  searchCustomer = new FormControl();
  searchItem = new FormControl();
  searchTimeframe = new FormControl();
  files: File[] = [];
  public yearList: PhysicalYear[] = new Array<PhysicalYear>();
  @ViewChild('ExcelImport') excelImport: TemplateRef<any>;
  @ViewChild('dialog') dialogTemplate: TemplateRef<any>;
  @ViewChild('searchItemInput', { static: true }) searchItemInput: ElementRef;
  @ViewChild('searchCustomerInput', { static: true }) searchCustomerInput: ElementRef;
  tempList = [];
  totalCalculatedList = [];
  chartDatasets = [];
  simulatedChartDatasets = [];
  barChartDatasets = [];
  simulatedBarChartDatasets = [];
  xAxis = [];
  yAxis = [];
  xAxisSimulated = [];
  view = [700, 700];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  legendTitle = 'Legend';
  legendPosition = 'right';
  showXAxisLabel = true;
  xAxisLabel = 'Sales QTY';
  showYAxisLabel = true;
  yAxisLabel = 'Time Period';
  showGridLines = true;
  innerPadding = '10%';
  animations: boolean = true;
  lineChartScheme = {
    name: 'coolthree',
    selectable: true,
    group: 'Ordinal',
    domain: ['#01579b', '#7aa3e5', '#a8385d', '#00bfa5']
  };

  comboBarScheme = {
    name: 'singleLightBlue',
    selectable: true,
    group: 'Ordinal',
    domain: ['#7aa3e5']
  };

  showRightYAxisLabel: boolean = true;
  yAxisLabelRight: string = '';
  tempColDefs = [];
  yearListTemp: PhysicalYear[];
  yearListForFilter: PhysicalYear[];
  graphList = [];
  chooserList = [
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Linear', key: 'Linear', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Curve', key: 'Curve', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Exponential', key: 'Exponential', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Logarithmic', key: 'Logarithmic', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Parabola', key: 'Parabola', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Moving Average', key: 'MovingAverage', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Single Expotential Smoothing', key: 'SingleExpotentialSmoothing', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Adaptive Smoothing', key: 'AdaptiveSmoothing', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Holts Linear Trend', key: 'HoltsLinearTrend', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Period Percentage Change', key: 'PeriodPercentageChange', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Seasonal Smoothing Method', key: 'SeasonalSmoothingMethod', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Seasonal Smoothing Average', key: 'SeasonalSmoothingAverage', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Seasonal Percentage Change', key: 'SeasonalPercentageChange', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Additive Decomposition', key: 'AdditiveDecomposition', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Winters Additive', key: 'WintersAdditive', checked: true, background: '#eee' },
    { isDropdown: true, tag: 'Forecast Method Sell-Through Projections', name: 'Current Algo Baseline ST Forecast', key: 'CurrentAlgoBaselineSTForecast', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'DP Baseline ST Fcst', key: 'DPBaselineSTFcst', checked: true, background: '#fff' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'CO Baseline ST Forecast', key: 'COBaselineSTForecast', checked: true, background: '#fff' },
    { isDropdown: false, tag: 'Forecast Method Sell-Through Projections', name: 'Actual Sales', key: 'ActualSales', checked: true, background: '#eee' },

    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Linear var to Actual %', key: 'LinearvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Curve var to Actual %', key: 'CurvevartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Exponential var to Actual %', key: 'ExponentialvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Logarithmic var to Actual %', key: 'LogarithmicvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Power var to Actual %', key: 'PowervartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Parabola var to Actual %', key: 'ParabolavartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Moving Average var to Actual %', key: 'MovingAveragevartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Single Expotential Smoothing var to Actual %', key: 'SingleExpotentialSmoothingvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Adaptive Smoothing var to Actual %', key: 'AdaptiveSmoothingvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Holts Linear Trend var to Actual %', key: 'HoltsLinearTrendvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Period Percentage Change var to Actual %', key: 'PeriodPercentageChangevartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Seasonal Smoothing Method var to Actual %', key: 'SeasonalSmoothingMethodvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Seasonal Smoothing Average var to Actual %', key: 'SeasonalSmoothingAveragevartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Seasonal Percentage Change var to Actual %', key: 'SeasonalPercentageChangevartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Additive Decomposition var to Actual %', key: 'AdditiveDecompositionvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Winters Additive var to Actual %', key: 'WintersAdditivevartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'Algo Baseline ST var to Actual %', key: 'AlgoBaselineSTvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'DP Baseline ST var to Actual %', key: 'DPBaselineSTvartoActual', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method % Variance to Actual', name: 'CO Baseline ST var to Actual %', key: 'COBaselineSTvartoActual', checked: true, background: '#eee' },

    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Linear var to Actual Units', key: 'LinearvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Curve var to Actual Units', key: 'CurvevartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Exponential var to Actual Units', key: 'ExponentialvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Logarithmic var to Actual Units', key: 'LogarithmicvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Power var to Actual Units', key: 'PowervartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Parabola var to Actual Units', key: 'ParabolavartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Moving Average var to Actual Units', key: 'MovingAveragevartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Single Expotential Smoothing var to Actual Units', key: 'SingleExpotentialSmoothingvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Adaptive Smoothing var to Actual Units', key: 'AdaptiveSmoothingvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Holts Linear Trend var to Actual Units', key: 'HoltsLinearTrendvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Period Percentage Change var to Actual Units', key: 'PeriodPercentageChangevartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Seasonal Smoothing Method var to Actual Units', key: 'SeasonalSmoothingMethodvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Seasonal Smoothing Average var to Actual Units', key: 'SeasonalSmoothingAveragevartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Seasonal Percentage Change var to Actual Units', key: 'SeasonalPercentageChangevartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Additive Decomposition var to Actual Units', key: 'AdditiveDecompositionvartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Winters Additive var to Actual Units', key: 'WintersAdditivevartoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'Algo Baseline ST to Actual Units', key: 'AlgoBaselineSTtoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'DP Baseline ST to Actual Units', key: 'DPBaselineSTtoActualUnits', checked: true, background: '#eee' },
    { isDropdown: false, tag: 'Forecast Method Unit Variance to Actual', name: 'CO Baseline ST var to Actual Units', key: 'COBaselineSTvartoActualUnits', checked: true, background: '#eee' },
  ];
  leftGroupList = [];
  tempGroupList = [];
  graphChooserList = [
    { tag: 'Forecast Method Sell-Through Projections', name: 'Linear', key: 'Linear', checked: true, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Curve', key: 'Curve', checked: true, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Exponential', key: 'Exponential', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Logarithmic', key: 'Logarithmic', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Parabola', key: 'Parabola', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Moving Average', key: 'MovingAverage', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Single Expotential Smoothing', key: 'SingleExpotentialSmoothing', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Adaptive Smoothing', key: 'AdaptiveSmoothing', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Holts Linear Trend', key: 'HoltsLinearTrend', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Period Percentage Change', key: 'PeriodPercentageChange', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Seasonal Smoothing Method', key: 'SeasonalSmoothingMethod', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Seasonal Smoothing Average', key: 'SeasonalSmoothingAverage', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Seasonal Percentage Change', key: 'SeasonalPercentageChange', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Additive Decomposition', key: 'AdditiveDecomposition', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Winters Additive', key: 'WintersAdditive', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Current Algo Baseline ST Forecast', key: 'CurrentAlgoBaselineSTForecast', checked: false, background: '#eee' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'DP Baseline ST Fcst', key: 'DPBaselineSTFcst', checked: true, background: '#fff' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'CO Baseline ST Forecast', key: 'COBaselineSTForecast', checked: true, background: '#fff' },
    { tag: 'Forecast Method Sell-Through Projections', name: 'Actual Sales', key: 'ActualSales', checked: false, background: '#eee' },

    { tag: 'Forecast Method % Variance to Actual', name: 'Linear var to Actual %', key: 'LinearvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Curve var to Actual %', key: 'CurvevartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Exponential var to Actual %', key: 'ExponentialvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Logarithmic var to Actual %', key: 'LogarithmicvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Power var to Actual %', key: 'PowervartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Parabola var to Actual %', key: 'ParabolavartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Moving Average var to Actual %', key: 'MovingAveragevartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Single Expotential Smoothing var to Actual %', key: 'SingleExpotentialSmoothingvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Adaptive Smoothing var to Actual %', key: 'AdaptiveSmoothingvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Holts Linear Trend var to Actual %', key: 'HoltsLinearTrendvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Period Percentage Change var to Actual %', key: 'PeriodPercentageChangevartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Seasonal Smoothing Method var to Actual %', key: 'SeasonalSmoothingMethodvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Seasonal Smoothing Average var to Actual %', key: 'SeasonalSmoothingAveragevartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Seasonal Percentage Change var to Actual %', key: 'SeasonalPercentageChangevartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Additive Decomposition var to Actual %', key: 'AdditiveDecompositionvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Winters Additive var to Actual %', key: 'WintersAdditivevartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'Algo Baseline ST var to Actual %', key: 'AlgoBaselineSTvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'DP Baseline ST var to Actual %', key: 'DPBaselineSTvartoActual', checked: false, background: '#eee' },
    { tag: 'Forecast Method % Variance to Actual', name: 'CO Baseline ST var to Actual %', key: 'COBaselineSTvartoActual', checked: false, background: '#eee' },

    { tag: 'Forecast Method Unit Variance to Actual', name: 'Linear var to Actual Units', key: 'LinearvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Curve var to Actual Units', key: 'CurvevartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Exponential var to Actual Units', key: 'ExponentialvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Logarithmic var to Actual Units', key: 'LogarithmicvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Power var to Actual Units', key: 'PowervartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Parabola var to Actual Units', key: 'ParabolavartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Moving Average var to Actual Units', key: 'MovingAveragevartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Single Expotential Smoothing var to Actual Units', key: 'SingleExpotentialSmoothingvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Adaptive Smoothing var to Actual Units', key: 'AdaptiveSmoothingvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Holts Linear Trend var to Actual Units', key: 'HoltsLinearTrendvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Period Percentage Change var to Actual Units', key: 'PeriodPercentageChangevartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Seasonal Smoothing Method var to Actual Units', key: 'SeasonalSmoothingMethodvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Seasonal Smoothing Average var to Actual Units', key: 'SeasonalSmoothingAveragevartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Seasonal Percentage Change var to Actual Units', key: 'SeasonalPercentageChangevartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Additive Decomposition var to Actual Units', key: 'AdditiveDecompositionvartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Winters Additive var to Actual Units', key: 'WintersAdditivevartoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'Algo Baseline ST to Actual Units', key: 'AlgoBaselineSTtoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'DP Baseline ST to Actual Units', key: 'DPBaselineSTtoActualUnits', checked: false, background: '#eee' },
    { tag: 'Forecast Method Unit Variance to Actual', name: 'CO Baseline ST var to Actual Units', key: 'COBaselineSTvartoActualUnits', checked: false, background: '#eee' },
  ]
  labelList;
  channelSelectedList;
  // public  date = { begin: new Date(2018, 7, 5), end: new Date(2018, 7, 25) };
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public location: Location,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public storage: LocalstorageService,
    public dialogRef: MatDialogRef<any>,
    public configurationService: ConfigurationService,
    public dialog: MatDialog,
    private _database: ChecklistDatabase) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    // this.treeControl = new FlatTreeControl<FoodFlatNode>(
    //   this.getLevel,
    //   this.isExpandable
    // );
    this.dataSourceDropdown = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );

    _database.dataChange.subscribe(data => {
      this.dataSourceDropdown.data = data;
    });
  }

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<FoodFlatNode, FoodNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<FoodNode, FoodFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: FoodFlatNode | null = null;

  /** The new item's name */
  newItemName = "";

  treeControl;

  treeFlattener: MatTreeFlattener<FoodNode, FoodFlatNode>;

  dataSourceDropdown: MatTreeFlatDataSource<FoodNode, FoodFlatNode>;

  /** The selection for checklist */
  checklistSelection;

  /// Filtering
  myControl = new FormControl();
  options: string[] = ["One", "Two", "Three"];
  filteredOptions: Observable<string[]>;

  getLevel = (node: FoodFlatNode) => node.level;

  isExpandable = (node: FoodFlatNode) => node.expandable;

  getChildren = (node: FoodNode): FoodNode[] => node.children;

  hasChild = (_: number, _nodeData: FoodFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: FoodFlatNode) => _nodeData.item === "";

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: FoodNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.item
        ? existingNode
        : new FoodFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.expandable = !!node.children;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: FoodFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: FoodFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: FoodFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: FoodFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: FoodFlatNode): void {
    let parent: FoodFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: FoodFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: FoodFlatNode): FoodFlatNode | null {
    console.log(this.checklistSelection.selected);
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  getSelectedItems(): string {
    if (!this.checklistSelection.selected.length) return "Select Product";
    return this.checklistSelection.selected.map(s => s.item).join(",");
  }

  filterChanged(filterText: string) {
    console.log("filterChanged", filterText);
    // ChecklistDatabase.filter method which actually filters the tree and gives back a tree structure
    this._database.filter(filterText);
    if (filterText) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }
  openDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(templateRef, { width: '500px', data: data || {} });
  }
  ngOnInit() {
    this.leftGroupList = [
      {
        name: 'Forecast Method Sell-Through Projections',
        rowspan: 19,
        color: '#8d009d'
      },
      {
        name: 'Forecast Method % Variance to Actual',
        rowspan: 19,
        color: '#f8486e'
      },
      {
        name: 'Forecast Method Unit Variance to Actual',
        rowspan: 19,
        color: '#53b7f4'
      }
    ];
    this.tempGroupList = JSON.parse(JSON.stringify(this.leftGroupList));
    console.log(this.chooserList);
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.yearList = [
      {
        title: 'FY20',
        ForecastMethod: { Linear: 1350, Curve: 1147.5, Exponential: 1215, Logarithmic: 1336.5, Power: 1244.7, Parabola: 1275.75, MovingAverage: 1471.5, SingleExpotentialSmoothing: 1404, AdaptiveSmoothing: 1348.65, HoltsLinearTrend: 1332.45, PeriodPercentageChange: 1485, SeasonalSmoothingMethod: 1290.6, SeasonalSmoothingAverage: 1363.5, SeasonalPercentageChange: 1390.5, AdditiveDecomposition: 1512, WintersAdditive: 1674, CurrentAlgoBaselineSTForecast: 1350, DPBaselineSTFcst: 1350, COBaselineSTForecast: 1350, ActualSales: 1375 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.0181818181818182, CurvevartoActual: -0.165454545454545, ExponentialvartoActual: -0.116363636363636, LogarithmicvartoActual: -0.028, PowervartoActual: -0.0947636363636363, ParabolavartoActual: -0.0721818181818182, MovingAveragevartoActual: 0.0701818181818182, SingleExpotentialSmoothingvartoActual: 0.0210909090909091, AdaptiveSmoothingvartoActual: -0.0191636363636363, HoltsLinearTrendvartoActual: -0.0309454545454545, PeriodPercentageChangevartoActual: 0.0800000000000002, SeasonalSmoothingMethodvartoActual: -0.0613818181818182, SeasonalSmoothingAveragevartoActual: -0.00836363636363636, SeasonalPercentageChangevartoActual: 0.0112727272727273, AdditiveDecompositionvartoActual: 0.0996363636363638, WintersAdditivevartoActual: 0.217454545454545, AlgoBaselineSTvartoActual: -0.0181818181818182, DPBaselineSTvartoActual: -0.0181818181818182, COBaselineSTvartoActual: -0.0181818181818182 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -25, CurvevartoActualUnits: -227.5, ExponentialvartoActualUnits: -160, LogarithmicvartoActualUnits: -38.5, PowervartoActualUnits: -130.3, ParabolavartoActualUnits: -99.25, MovingAveragevartoActualUnits: 96.5, SingleExpotentialSmoothingvartoActualUnits: 29, AdaptiveSmoothingvartoActualUnits: -26.3499999999999, HoltsLinearTrendvartoActualUnits: -42.55, PeriodPercentageChangevartoActualUnits: 110, SeasonalSmoothingMethodvartoActualUnits: -84.4000000000001, SeasonalSmoothingAveragevartoActualUnits: -11.5, SeasonalPercentageChangevartoActualUnits: 15.5, AdditiveDecompositionvartoActualUnits: 137, WintersAdditivevartoActualUnits: 299, AlgoBaselineSTtoActualUnits: -25, DPBaselineSTtoActualUnits: -25, COBaselineSTvartoActualUnits: -25 },

        halfList: [
          {
            title: 'H2 FY20',
            ForecastMethod: { Linear: 1350, Curve: 1147.5, Exponential: 1215, Logarithmic: 1336.5, Power: 1244.7, Parabola: 1275.75, MovingAverage: 1471.5, SingleExpotentialSmoothing: 1404, AdaptiveSmoothing: 1348.65, HoltsLinearTrend: 1332.45, PeriodPercentageChange: 1485, SeasonalSmoothingMethod: 1290.6, SeasonalSmoothingAverage: 1363.5, SeasonalPercentageChange: 1390.5, AdditiveDecomposition: 1512, WintersAdditive: 1674, CurrentAlgoBaselineSTForecast: 1350, DPBaselineSTFcst: 1350, COBaselineSTForecast: 1350, ActualSales: 1375 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.0181818181818182, CurvevartoActual: -0.165454545454545, ExponentialvartoActual: -0.116363636363636, LogarithmicvartoActual: -0.028, PowervartoActual: -0.0947636363636363, ParabolavartoActual: -0.0721818181818182, MovingAveragevartoActual: 0.0701818181818182, SingleExpotentialSmoothingvartoActual: 0.0210909090909091, AdaptiveSmoothingvartoActual: -0.0191636363636363, HoltsLinearTrendvartoActual: -0.0309454545454545, PeriodPercentageChangevartoActual: 0.0800000000000002, SeasonalSmoothingMethodvartoActual: -0.0613818181818182, SeasonalSmoothingAveragevartoActual: -0.00836363636363636, SeasonalPercentageChangevartoActual: 0.0112727272727273, AdditiveDecompositionvartoActual: 0.0996363636363638, WintersAdditivevartoActual: 0.217454545454545, AlgoBaselineSTvartoActual: -0.0181818181818182, DPBaselineSTvartoActual: -0.0181818181818182, COBaselineSTvartoActual: -0.0181818181818182 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -25, CurvevartoActualUnits: -227.5, ExponentialvartoActualUnits: -160, LogarithmicvartoActualUnits: -38.5, PowervartoActualUnits: -130.3, ParabolavartoActualUnits: -99.25, MovingAveragevartoActualUnits: 96.5, SingleExpotentialSmoothingvartoActualUnits: 29, AdaptiveSmoothingvartoActualUnits: -26.3499999999999, HoltsLinearTrendvartoActualUnits: -42.55, PeriodPercentageChangevartoActualUnits: 110, SeasonalSmoothingMethodvartoActualUnits: -84.4000000000001, SeasonalSmoothingAveragevartoActualUnits: -11.5, SeasonalPercentageChangevartoActualUnits: 15.5, AdditiveDecompositionvartoActualUnits: 137, WintersAdditivevartoActualUnits: 299, AlgoBaselineSTtoActualUnits: -25, DPBaselineSTtoActualUnits: -25, COBaselineSTvartoActualUnits: -25 },
            quarterList: [
              {
                title: 'Q4 FY20',
                ForecastMethod: { Linear: 1350, Curve: 1147.5, Exponential: 1215, Logarithmic: 1336.5, Power: 1244.7, Parabola: 1275.75, MovingAverage: 1471.5, SingleExpotentialSmoothing: 1404, AdaptiveSmoothing: 1348.65, HoltsLinearTrend: 1332.45, PeriodPercentageChange: 1485, SeasonalSmoothingMethod: 1290.6, SeasonalSmoothingAverage: 1363.5, SeasonalPercentageChange: 1390.5, AdditiveDecomposition: 1512, WintersAdditive: 1674, CurrentAlgoBaselineSTForecast: 1350, DPBaselineSTFcst: 1350, COBaselineSTForecast: 1350, ActualSales: 1375 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.0181818181818182, CurvevartoActual: -0.165454545454545, ExponentialvartoActual: -0.116363636363636, LogarithmicvartoActual: -0.028, PowervartoActual: -0.0947636363636363, ParabolavartoActual: -0.0721818181818182, MovingAveragevartoActual: 0.0701818181818182, SingleExpotentialSmoothingvartoActual: 0.0210909090909091, AdaptiveSmoothingvartoActual: -0.0191636363636363, HoltsLinearTrendvartoActual: -0.0309454545454545, PeriodPercentageChangevartoActual: 0.0800000000000002, SeasonalSmoothingMethodvartoActual: -0.0613818181818182, SeasonalSmoothingAveragevartoActual: -0.00836363636363636, SeasonalPercentageChangevartoActual: 0.0112727272727273, AdditiveDecompositionvartoActual: 0.0996363636363638, WintersAdditivevartoActual: 0.217454545454545, AlgoBaselineSTvartoActual: -0.0181818181818182, DPBaselineSTvartoActual: -0.0181818181818182, COBaselineSTvartoActual: -0.0181818181818182 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -25, CurvevartoActualUnits: -227.5, ExponentialvartoActualUnits: -160, LogarithmicvartoActualUnits: -38.5, PowervartoActualUnits: -130.3, ParabolavartoActualUnits: -99.25, MovingAveragevartoActualUnits: 96.5, SingleExpotentialSmoothingvartoActualUnits: 29, AdaptiveSmoothingvartoActualUnits: -26.3499999999999, HoltsLinearTrendvartoActualUnits: -42.55, PeriodPercentageChangevartoActualUnits: 110, SeasonalSmoothingMethodvartoActualUnits: -84.4000000000001, SeasonalSmoothingAveragevartoActualUnits: -11.5, SeasonalPercentageChangevartoActualUnits: 15.5, AdditiveDecompositionvartoActualUnits: 137, WintersAdditivevartoActualUnits: 299, AlgoBaselineSTtoActualUnits: -25, DPBaselineSTtoActualUnits: -25, COBaselineSTvartoActualUnits: -25 },
                monthList: [
                  {
                    title: 'November FY20',
                            ForecastMethod: { Linear: 1350, Curve: 1147.5, Exponential: 1215, Logarithmic: 1336.5, Power: 1244.7, Parabola: 1275.75, MovingAverage: 1471.5, SingleExpotentialSmoothing: 1404, AdaptiveSmoothing: 1348.65, HoltsLinearTrend: 1332.45, PeriodPercentageChange: 1485, SeasonalSmoothingMethod: 1290.6, SeasonalSmoothingAverage: 1363.5, SeasonalPercentageChange: 1390.5, AdditiveDecomposition: 1512, WintersAdditive: 1674, CurrentAlgoBaselineSTForecast: 1350, DPBaselineSTFcst: 1350, COBaselineSTForecast: 1350, ActualSales: 1375 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.0181818181818182, CurvevartoActual: -0.165454545454545, ExponentialvartoActual: -0.116363636363636, LogarithmicvartoActual: -0.028, PowervartoActual: -0.0947636363636363, ParabolavartoActual: -0.0721818181818182, MovingAveragevartoActual: 0.0701818181818182, SingleExpotentialSmoothingvartoActual: 0.0210909090909091, AdaptiveSmoothingvartoActual: -0.0191636363636363, HoltsLinearTrendvartoActual: -0.0309454545454545, PeriodPercentageChangevartoActual: 0.0800000000000002, SeasonalSmoothingMethodvartoActual: -0.0613818181818182, SeasonalSmoothingAveragevartoActual: -0.00836363636363636, SeasonalPercentageChangevartoActual: 0.0112727272727273, AdditiveDecompositionvartoActual: 0.0996363636363638, WintersAdditivevartoActual: 0.217454545454545, AlgoBaselineSTvartoActual: -0.0181818181818182, DPBaselineSTvartoActual: -0.0181818181818182, COBaselineSTvartoActual: -0.0181818181818182 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -25, CurvevartoActualUnits: -227.5, ExponentialvartoActualUnits: -160, LogarithmicvartoActualUnits: -38.5, PowervartoActualUnits: -130.3, ParabolavartoActualUnits: -99.25, MovingAveragevartoActualUnits: 96.5, SingleExpotentialSmoothingvartoActualUnits: 29, AdaptiveSmoothingvartoActualUnits: -26.3499999999999, HoltsLinearTrendvartoActualUnits: -42.55, PeriodPercentageChangevartoActualUnits: 110, SeasonalSmoothingMethodvartoActualUnits: -84.4000000000001, SeasonalSmoothingAveragevartoActualUnits: -11.5, SeasonalPercentageChangevartoActualUnits: 15.5, AdditiveDecompositionvartoActualUnits: 137, WintersAdditivevartoActualUnits: 299, AlgoBaselineSTtoActualUnits: -25, DPBaselineSTtoActualUnits: -25, COBaselineSTvartoActualUnits: -25 },

                    weekList: [
                      {
                        title: '11/01/2020',
                        ForecastMethod: { Linear: 1350, Curve: 1147.5, Exponential: 1215, Logarithmic: 1336.5, Power: 1244.7, Parabola: 1275.75, MovingAverage: 1471.5, SingleExpotentialSmoothing: 1404, AdaptiveSmoothing: 1348.65, HoltsLinearTrend: 1332.45, PeriodPercentageChange: 1485, SeasonalSmoothingMethod: 1290.6, SeasonalSmoothingAverage: 1363.5, SeasonalPercentageChange: 1390.5, AdditiveDecomposition: 1512, WintersAdditive: 1674, CurrentAlgoBaselineSTForecast: 1350, DPBaselineSTFcst: 1350, COBaselineSTForecast: 1350, ActualSales: 1375 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.0181818181818182, CurvevartoActual: -0.165454545454545, ExponentialvartoActual: -0.116363636363636, LogarithmicvartoActual: -0.028, PowervartoActual: -0.0947636363636363, ParabolavartoActual: -0.0721818181818182, MovingAveragevartoActual: 0.0701818181818182, SingleExpotentialSmoothingvartoActual: 0.0210909090909091, AdaptiveSmoothingvartoActual: -0.0191636363636363, HoltsLinearTrendvartoActual: -0.0309454545454545, PeriodPercentageChangevartoActual: 0.0800000000000002, SeasonalSmoothingMethodvartoActual: -0.0613818181818182, SeasonalSmoothingAveragevartoActual: -0.00836363636363636, SeasonalPercentageChangevartoActual: 0.0112727272727273, AdditiveDecompositionvartoActual: 0.0996363636363638, WintersAdditivevartoActual: 0.217454545454545, AlgoBaselineSTvartoActual: -0.0181818181818182, DPBaselineSTvartoActual: -0.0181818181818182, COBaselineSTvartoActual: -0.0181818181818182 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -25, CurvevartoActualUnits: -227.5, ExponentialvartoActualUnits: -160, LogarithmicvartoActualUnits: -38.5, PowervartoActualUnits: -130.3, ParabolavartoActualUnits: -99.25, MovingAveragevartoActualUnits: 96.5, SingleExpotentialSmoothingvartoActualUnits: 29, AdaptiveSmoothingvartoActualUnits: -26.3499999999999, HoltsLinearTrendvartoActualUnits: -42.55, PeriodPercentageChangevartoActualUnits: 110, SeasonalSmoothingMethodvartoActualUnits: -84.4000000000001, SeasonalSmoothingAveragevartoActualUnits: -11.5, SeasonalPercentageChangevartoActualUnits: 15.5, AdditiveDecompositionvartoActualUnits: 137, WintersAdditivevartoActualUnits: 299, AlgoBaselineSTtoActualUnits: -25, DPBaselineSTtoActualUnits: -25, COBaselineSTvartoActualUnits: -25 },

                      },
                      {
                        title: '11/08/2020',
                        ForecastMethod: { Linear: 900, Curve: 765, Exponential: 810, Logarithmic: 891, Power: 829.8, Parabola: 850.5, MovingAverage: 981, SingleExpotentialSmoothing: 936, AdaptiveSmoothing: 899.1, HoltsLinearTrend: 888.3, PeriodPercentageChange: 990, SeasonalSmoothingMethod: 860.4, SeasonalSmoothingAverage: 909, SeasonalPercentageChange: 927, AdditiveDecomposition: 1008, WintersAdditive: 1116, CurrentAlgoBaselineSTForecast: 900, DPBaselineSTFcst: 900, COBaselineSTForecast: 900, ActualSales: 1254 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.282296650717703, CurvevartoActual: -0.389952153110048, ExponentialvartoActual: -0.354066985645933, LogarithmicvartoActual: -0.289473684210526, PowervartoActual: -0.338277511961722, ParabolavartoActual: -0.32177033492823, MovingAveragevartoActual: -0.217703349282297, SingleExpotentialSmoothingvartoActual: -0.253588516746411, AdaptiveSmoothingvartoActual: -0.283014354066986, HoltsLinearTrendvartoActual: -0.291626794258373, PeriodPercentageChangevartoActual: -0.210526315789474, SeasonalSmoothingMethodvartoActual: -0.313875598086124, SeasonalSmoothingAveragevartoActual: -0.27511961722488, SeasonalPercentageChangevartoActual: -0.260765550239234, AdditiveDecompositionvartoActual: -0.196172248803828, WintersAdditivevartoActual: -0.110047846889952, AlgoBaselineSTvartoActual: -0.282296650717703, DPBaselineSTvartoActual: -0.282296650717703, COBaselineSTvartoActual: -0.282296650717703 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -354, CurvevartoActualUnits: -489, ExponentialvartoActualUnits: -444, LogarithmicvartoActualUnits: -363, PowervartoActualUnits: -424.2, ParabolavartoActualUnits: -403.5, MovingAveragevartoActualUnits: -273, SingleExpotentialSmoothingvartoActualUnits: -318, AdaptiveSmoothingvartoActualUnits: -354.9, HoltsLinearTrendvartoActualUnits: -365.7, PeriodPercentageChangevartoActualUnits: -264, SeasonalSmoothingMethodvartoActualUnits: -393.6, SeasonalSmoothingAveragevartoActualUnits: -345, SeasonalPercentageChangevartoActualUnits: -327, AdditiveDecompositionvartoActualUnits: -246, WintersAdditivevartoActualUnits: -138, AlgoBaselineSTtoActualUnits: -354, DPBaselineSTtoActualUnits: -354, COBaselineSTvartoActualUnits: -354 }

                      },
                      {
                        title: '11/15/2020',
                        ForecastMethod: { Linear: 900, Curve: 765, Exponential: 810, Logarithmic: 891, Power: 829.8, Parabola: 850.5, MovingAverage: 981, SingleExpotentialSmoothing: 936, AdaptiveSmoothing: 899.1, HoltsLinearTrend: 888.3, PeriodPercentageChange: 990, SeasonalSmoothingMethod: 860.4, SeasonalSmoothingAverage: 909, SeasonalPercentageChange: 927, AdditiveDecomposition: 1008, WintersAdditive: 1116, CurrentAlgoBaselineSTForecast: 900, DPBaselineSTFcst: 900, COBaselineSTForecast: 900, ActualSales: 0 }, ForecastMethodVarianceActual: { LinearvartoActual: 0, CurvevartoActual: 0, ExponentialvartoActual: 0, LogarithmicvartoActual: 0, PowervartoActual: 0, ParabolavartoActual: 0, MovingAveragevartoActual: 0, SingleExpotentialSmoothingvartoActual: 0, AdaptiveSmoothingvartoActual: 0, HoltsLinearTrendvartoActual: 0, PeriodPercentageChangevartoActual: 0, SeasonalSmoothingMethodvartoActual: 0, SeasonalSmoothingAveragevartoActual: 0, SeasonalPercentageChangevartoActual: 0, AdditiveDecompositionvartoActual: 0, WintersAdditivevartoActual: 0, AlgoBaselineSTvartoActual: 0, DPBaselineSTvartoActual: 0, COBaselineSTvartoActual: 0 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: 0, CurvevartoActualUnits: 0, ExponentialvartoActualUnits: 0, LogarithmicvartoActualUnits: 0, PowervartoActualUnits: 0, ParabolavartoActualUnits: 0, MovingAveragevartoActualUnits: 0, SingleExpotentialSmoothingvartoActualUnits: 0, AdaptiveSmoothingvartoActualUnits: 0, HoltsLinearTrendvartoActualUnits: 0, PeriodPercentageChangevartoActualUnits: 0, SeasonalSmoothingMethodvartoActualUnits: 0, SeasonalSmoothingAveragevartoActualUnits: 0, SeasonalPercentageChangevartoActualUnits: 0, AdditiveDecompositionvartoActualUnits: 0, WintersAdditivevartoActualUnits: 0, AlgoBaselineSTtoActualUnits: 0, DPBaselineSTtoActualUnits: 0, COBaselineSTvartoActualUnits: 0 }

                      },
                      {
                        title: '11/22/2020',
                        ForecastMethod: { Linear: 5000, Curve: 4250, Exponential: 4500, Logarithmic: 4950, Power: 4610, Parabola: 4725, MovingAverage: 5450, SingleExpotentialSmoothing: 5200, AdaptiveSmoothing: 4995, HoltsLinearTrend: 4935, PeriodPercentageChange: 5500, SeasonalSmoothingMethod: 4780, SeasonalSmoothingAverage: 5050, SeasonalPercentageChange: 5150, AdditiveDecomposition: 5600, WintersAdditive: 6200, CurrentAlgoBaselineSTForecast: 5000, DPBaselineSTFcst: 5000, COBaselineSTForecast: 5000, ActualSales: 0 }, ForecastMethodVarianceActual: { LinearvartoActual: 0, CurvevartoActual: 0, ExponentialvartoActual: 0, LogarithmicvartoActual: 0, PowervartoActual: 0, ParabolavartoActual: 0, MovingAveragevartoActual: 0, SingleExpotentialSmoothingvartoActual: 0, AdaptiveSmoothingvartoActual: 0, HoltsLinearTrendvartoActual: 0, PeriodPercentageChangevartoActual: 0, SeasonalSmoothingMethodvartoActual: 0, SeasonalSmoothingAveragevartoActual: 0, SeasonalPercentageChangevartoActual: 0, AdditiveDecompositionvartoActual: 0, WintersAdditivevartoActual: 0, AlgoBaselineSTvartoActual: 0, DPBaselineSTvartoActual: 0, COBaselineSTvartoActual: 0 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: 0, CurvevartoActualUnits: 0, ExponentialvartoActualUnits: 0, LogarithmicvartoActualUnits: 0, PowervartoActualUnits: 0, ParabolavartoActualUnits: 0, MovingAveragevartoActualUnits: 0, SingleExpotentialSmoothingvartoActualUnits: 0, AdaptiveSmoothingvartoActualUnits: 0, HoltsLinearTrendvartoActualUnits: 0, PeriodPercentageChangevartoActualUnits: 0, SeasonalSmoothingMethodvartoActualUnits: 0, SeasonalSmoothingAveragevartoActualUnits: 0, SeasonalPercentageChangevartoActualUnits: 0, AdditiveDecompositionvartoActualUnits: 0, WintersAdditivevartoActualUnits: 0, AlgoBaselineSTtoActualUnits: 0, DPBaselineSTtoActualUnits: 0, COBaselineSTvartoActualUnits: 0 }

                      }

                    ]
                  },
                  {
                    title: 'December FY20',
                    ForecastMethod: { Linear: 1350, Curve: 1147.5, Exponential: 1215, Logarithmic: 1336.5, Power: 1244.7, Parabola: 1275.75, MovingAverage: 1471.5, SingleExpotentialSmoothing: 1404, AdaptiveSmoothing: 1348.65, HoltsLinearTrend: 1332.45, PeriodPercentageChange: 1485, SeasonalSmoothingMethod: 1290.6, SeasonalSmoothingAverage: 1363.5, SeasonalPercentageChange: 1390.5, AdditiveDecomposition: 1512, WintersAdditive: 1674, CurrentAlgoBaselineSTForecast: 1350, DPBaselineSTFcst: 1350, COBaselineSTForecast: 1350, ActualSales: 1375 }, ForecastMethodVarianceActual: { LinearvartoActual: -0.0181818181818182, CurvevartoActual: -0.165454545454545, ExponentialvartoActual: -0.116363636363636, LogarithmicvartoActual: -0.028, PowervartoActual: -0.0947636363636363, ParabolavartoActual: -0.0721818181818182, MovingAveragevartoActual: 0.0701818181818182, SingleExpotentialSmoothingvartoActual: 0.0210909090909091, AdaptiveSmoothingvartoActual: -0.0191636363636363, HoltsLinearTrendvartoActual: -0.0309454545454545, PeriodPercentageChangevartoActual: 0.0800000000000002, SeasonalSmoothingMethodvartoActual: -0.0613818181818182, SeasonalSmoothingAveragevartoActual: -0.00836363636363636, SeasonalPercentageChangevartoActual: 0.0112727272727273, AdditiveDecompositionvartoActual: 0.0996363636363638, WintersAdditivevartoActual: 0.217454545454545, AlgoBaselineSTvartoActual: -0.0181818181818182, DPBaselineSTvartoActual: -0.0181818181818182, COBaselineSTvartoActual: -0.0181818181818182 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: -25, CurvevartoActualUnits: -227.5, ExponentialvartoActualUnits: -160, LogarithmicvartoActualUnits: -38.5, PowervartoActualUnits: -130.3, ParabolavartoActualUnits: -99.25, MovingAveragevartoActualUnits: 96.5, SingleExpotentialSmoothingvartoActualUnits: 29, AdaptiveSmoothingvartoActualUnits: -26.3499999999999, HoltsLinearTrendvartoActualUnits: -42.55, PeriodPercentageChangevartoActualUnits: 110, SeasonalSmoothingMethodvartoActualUnits: -84.4000000000001, SeasonalSmoothingAveragevartoActualUnits: -11.5, SeasonalPercentageChangevartoActualUnits: 15.5, AdditiveDecompositionvartoActualUnits: 137, WintersAdditivevartoActualUnits: 299, AlgoBaselineSTtoActualUnits: -25, DPBaselineSTtoActualUnits: -25, COBaselineSTvartoActualUnits: -25 },
                    weekList: [
                      {
                        title: '11/29/2020',
                        ForecastMethod: { Linear: 10800, Curve: 9180, Exponential: 9720, Logarithmic: 10692, Power: 9957.6, Parabola: 10206, MovingAverage: 11772, SingleExpotentialSmoothing: 11232, AdaptiveSmoothing: 10789.2, HoltsLinearTrend: 10659.6, PeriodPercentageChange: 11880, SeasonalSmoothingMethod: 10324.8, SeasonalSmoothingAverage: 10908, SeasonalPercentageChange: 11124, AdditiveDecomposition: 12096, WintersAdditive: 13392, CurrentAlgoBaselineSTForecast: 10800, DPBaselineSTFcst: 10800, COBaselineSTForecast: 10800, ActualSales: 0 }, ForecastMethodVarianceActual: { LinearvartoActual: 0, CurvevartoActual: 0, ExponentialvartoActual: 0, LogarithmicvartoActual: 0, PowervartoActual: 0, ParabolavartoActual: 0, MovingAveragevartoActual: 0, SingleExpotentialSmoothingvartoActual: 0, AdaptiveSmoothingvartoActual: 0, HoltsLinearTrendvartoActual: 0, PeriodPercentageChangevartoActual: 0, SeasonalSmoothingMethodvartoActual: 0, SeasonalSmoothingAveragevartoActual: 0, SeasonalPercentageChangevartoActual: 0, AdditiveDecompositionvartoActual: 0, WintersAdditivevartoActual: 0, AlgoBaselineSTvartoActual: 0, DPBaselineSTvartoActual: 0, COBaselineSTvartoActual: 0 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: 0, CurvevartoActualUnits: 0, ExponentialvartoActualUnits: 0, LogarithmicvartoActualUnits: 0, PowervartoActualUnits: 0, ParabolavartoActualUnits: 0, MovingAveragevartoActualUnits: 0, SingleExpotentialSmoothingvartoActualUnits: 0, AdaptiveSmoothingvartoActualUnits: 0, HoltsLinearTrendvartoActualUnits: 0, PeriodPercentageChangevartoActualUnits: 0, SeasonalSmoothingMethodvartoActualUnits: 0, SeasonalSmoothingAveragevartoActualUnits: 0, SeasonalPercentageChangevartoActualUnits: 0, AdditiveDecompositionvartoActualUnits: 0, WintersAdditivevartoActualUnits: 0, AlgoBaselineSTtoActualUnits: 0, DPBaselineSTtoActualUnits: 0, COBaselineSTvartoActualUnits: 0 }

                      },
                      {
                        title: '12/06/2020',
                        ForecastMethod: { Linear: 10800, Curve: 9180, Exponential: 9720, Logarithmic: 10692, Power: 9957.6, Parabola: 10206, MovingAverage: 11772, SingleExpotentialSmoothing: 11232, AdaptiveSmoothing: 10789.2, HoltsLinearTrend: 10659.6, PeriodPercentageChange: 11880, SeasonalSmoothingMethod: 10324.8, SeasonalSmoothingAverage: 10908, SeasonalPercentageChange: 11124, AdditiveDecomposition: 12096, WintersAdditive: 13392, CurrentAlgoBaselineSTForecast: 10800, DPBaselineSTFcst: 10800, COBaselineSTForecast: 10800, ActualSales: 0 }, ForecastMethodVarianceActual: { LinearvartoActual: 0, CurvevartoActual: 0, ExponentialvartoActual: 0, LogarithmicvartoActual: 0, PowervartoActual: 0, ParabolavartoActual: 0, MovingAveragevartoActual: 0, SingleExpotentialSmoothingvartoActual: 0, AdaptiveSmoothingvartoActual: 0, HoltsLinearTrendvartoActual: 0, PeriodPercentageChangevartoActual: 0, SeasonalSmoothingMethodvartoActual: 0, SeasonalSmoothingAveragevartoActual: 0, SeasonalPercentageChangevartoActual: 0, AdditiveDecompositionvartoActual: 0, WintersAdditivevartoActual: 0, AlgoBaselineSTvartoActual: 0, DPBaselineSTvartoActual: 0, COBaselineSTvartoActual: 0 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: 0, CurvevartoActualUnits: 0, ExponentialvartoActualUnits: 0, LogarithmicvartoActualUnits: 0, PowervartoActualUnits: 0, ParabolavartoActualUnits: 0, MovingAveragevartoActualUnits: 0, SingleExpotentialSmoothingvartoActualUnits: 0, AdaptiveSmoothingvartoActualUnits: 0, HoltsLinearTrendvartoActualUnits: 0, PeriodPercentageChangevartoActualUnits: 0, SeasonalSmoothingMethodvartoActualUnits: 0, SeasonalSmoothingAveragevartoActualUnits: 0, SeasonalPercentageChangevartoActualUnits: 0, AdditiveDecompositionvartoActualUnits: 0, WintersAdditivevartoActualUnits: 0, AlgoBaselineSTtoActualUnits: 0, DPBaselineSTtoActualUnits: 0, COBaselineSTvartoActualUnits: 0 }

                      },
                      {
                        title: '12/13/2020',
                        ForecastMethod: { Linear: 9000, Curve: 7650, Exponential: 8100, Logarithmic: 8910, Power: 8298, Parabola: 8505, MovingAverage: 9810, SingleExpotentialSmoothing: 9360, AdaptiveSmoothing: 8991, HoltsLinearTrend: 8883, PeriodPercentageChange: 9900, SeasonalSmoothingMethod: 8604, SeasonalSmoothingAverage: 9090, SeasonalPercentageChange: 9270, AdditiveDecomposition: 10080, WintersAdditive: 11160, CurrentAlgoBaselineSTForecast: 9000, DPBaselineSTFcst: 9000, COBaselineSTForecast: 9000, ActualSales: 0 }, ForecastMethodVarianceActual: { LinearvartoActual: 0, CurvevartoActual: 0, ExponentialvartoActual: 0, LogarithmicvartoActual: 0, PowervartoActual: 0, ParabolavartoActual: 0, MovingAveragevartoActual: 0, SingleExpotentialSmoothingvartoActual: 0, AdaptiveSmoothingvartoActual: 0, HoltsLinearTrendvartoActual: 0, PeriodPercentageChangevartoActual: 0, SeasonalSmoothingMethodvartoActual: 0, SeasonalSmoothingAveragevartoActual: 0, SeasonalPercentageChangevartoActual: 0, AdditiveDecompositionvartoActual: 0, WintersAdditivevartoActual: 0, AlgoBaselineSTvartoActual: 0, DPBaselineSTvartoActual: 0, COBaselineSTvartoActual: 0 }, ForecastMethodUnitVarianceActual: { LinearvartoActualUnits: 0, CurvevartoActualUnits: 0, ExponentialvartoActualUnits: 0, LogarithmicvartoActualUnits: 0, PowervartoActualUnits: 0, ParabolavartoActualUnits: 0, MovingAveragevartoActualUnits: 0, SingleExpotentialSmoothingvartoActualUnits: 0, AdaptiveSmoothingvartoActualUnits: 0, HoltsLinearTrendvartoActualUnits: 0, PeriodPercentageChangevartoActualUnits: 0, SeasonalSmoothingMethodvartoActualUnits: 0, SeasonalSmoothingAveragevartoActualUnits: 0, SeasonalPercentageChangevartoActualUnits: 0, AdditiveDecompositionvartoActualUnits: 0, WintersAdditivevartoActualUnits: 0, AlgoBaselineSTtoActualUnits: 0, DPBaselineSTtoActualUnits: 0, COBaselineSTvartoActualUnits: 0 }

                      },
                      {
                        title: '12/20/2020',
                        ForecastMethod: { Linear:9000,Curve:7650,Exponential:8100,Logarithmic:8910,Power:8298,Parabola:8505,MovingAverage:9810,SingleExpotentialSmoothing:9360,AdaptiveSmoothing:8991,HoltsLinearTrend:8883,PeriodPercentageChange:9900,SeasonalSmoothingMethod:8604,SeasonalSmoothingAverage:9090,SeasonalPercentageChange:9270,AdditiveDecomposition:10080,WintersAdditive:11160,CurrentAlgoBaselineSTForecast:9000,DPBaselineSTFcst:9000,COBaselineSTForecast:9000,ActualSales:0},ForecastMethodVarianceActual: { LinearvartoActual:0,CurvevartoActual:0,ExponentialvartoActual:0,LogarithmicvartoActual:0,PowervartoActual:0,ParabolavartoActual:0,MovingAveragevartoActual:0,SingleExpotentialSmoothingvartoActual:0,AdaptiveSmoothingvartoActual:0,HoltsLinearTrendvartoActual:0,PeriodPercentageChangevartoActual:0,SeasonalSmoothingMethodvartoActual:0,SeasonalSmoothingAveragevartoActual:0,SeasonalPercentageChangevartoActual:0,AdditiveDecompositionvartoActual:0,WintersAdditivevartoActual:0,AlgoBaselineSTvartoActual:0,DPBaselineSTvartoActual:0,COBaselineSTvartoActual:0},ForecastMethodUnitVarianceActual: { LinearvartoActualUnits:0,CurvevartoActualUnits:0,ExponentialvartoActualUnits:0,LogarithmicvartoActualUnits:0,PowervartoActualUnits:0,ParabolavartoActualUnits:0,MovingAveragevartoActualUnits:0,SingleExpotentialSmoothingvartoActualUnits:0,AdaptiveSmoothingvartoActualUnits:0,HoltsLinearTrendvartoActualUnits:0,PeriodPercentageChangevartoActualUnits:0,SeasonalSmoothingMethodvartoActualUnits:0,SeasonalSmoothingAveragevartoActualUnits:0,SeasonalPercentageChangevartoActualUnits:0,AdditiveDecompositionvartoActualUnits:0,WintersAdditivevartoActualUnits:0,AlgoBaselineSTtoActualUnits:0,DPBaselineSTtoActualUnits:0,COBaselineSTvartoActualUnits:0},

                      },
                      {
                        title: '12/27/2020',
                        ForecastMethod: { Linear:4500,Curve:3825,Exponential:4050,Logarithmic:4455,Power:4149,Parabola:4252.5,MovingAverage:4905,SingleExpotentialSmoothing:4680,AdaptiveSmoothing:4495.5,HoltsLinearTrend:4441.5,PeriodPercentageChange:4950,SeasonalSmoothingMethod:4302,SeasonalSmoothingAverage:4545,SeasonalPercentageChange:4635,AdditiveDecomposition:5040,WintersAdditive:5580,CurrentAlgoBaselineSTForecast:4500,DPBaselineSTFcst:4500,COBaselineSTForecast:4500,ActualSales:0},ForecastMethodVarianceActual: { LinearvartoActual:0,CurvevartoActual:0,ExponentialvartoActual:0,LogarithmicvartoActual:0,PowervartoActual:0,ParabolavartoActual:0,MovingAveragevartoActual:0,SingleExpotentialSmoothingvartoActual:0,AdaptiveSmoothingvartoActual:0,HoltsLinearTrendvartoActual:0,PeriodPercentageChangevartoActual:0,SeasonalSmoothingMethodvartoActual:0,SeasonalSmoothingAveragevartoActual:0,SeasonalPercentageChangevartoActual:0,AdditiveDecompositionvartoActual:0,WintersAdditivevartoActual:0,AlgoBaselineSTvartoActual:0,DPBaselineSTvartoActual:0,COBaselineSTvartoActual:0},ForecastMethodUnitVarianceActual: { LinearvartoActualUnits:0,CurvevartoActualUnits:0,ExponentialvartoActualUnits:0,LogarithmicvartoActualUnits:0,PowervartoActualUnits:0,ParabolavartoActualUnits:0,MovingAveragevartoActualUnits:0,SingleExpotentialSmoothingvartoActualUnits:0,AdaptiveSmoothingvartoActualUnits:0,HoltsLinearTrendvartoActualUnits:0,PeriodPercentageChangevartoActualUnits:0,SeasonalSmoothingMethodvartoActualUnits:0,SeasonalSmoothingAveragevartoActualUnits:0,SeasonalPercentageChangevartoActualUnits:0,AdditiveDecompositionvartoActualUnits:0,WintersAdditivevartoActualUnits:0,AlgoBaselineSTtoActualUnits:0,DPBaselineSTtoActualUnits:0,COBaselineSTvartoActualUnits:0},

                      },
                    ]
                  },
                ]
              },
            ]
          }
        ]
      },
      // {
      //   title: 'FY21',

      //   halfList: [
      //     {
      //       title: 'H1FY21',

      //       quarterList: [
      //         {
      //           title: 'Q1FY21',

      //           monthList: [
      //             {
      //               title: 'January FY21',

      //               weekList: [
      //                 {
      //                   title: '01/03/2021',
      //                 },
      //                 {
      //                   title: '01/10/2021',
      //                 },
      //                 {
      //                   title: '01/17/2021',
      //                 },
      //                 {
      //                   title: '01/24/2021',
      //                 },
      //               ]
      //             },
      //             {
      //               title: 'February FY21',

      //               weekList: [
      //                 {
      //                   title: '01/31/2021',
      //                 },
      //                 {
      //                   title: '02/07/2021',
      //                 },

      //                 {
      //                   title: '02/14/2021',
      //                 },
      //                 {
      //                   title: '02/21/2021',
      //                 }
      //               ]
      //             },
      //             {
      //               title: 'March FY21',

      //               weekList: [
      //                 {
      //                   title: '02/28/2021',
      //                 },
      //                 {
      //                   title: '03/07/2021',
      //                 },
      //                 {
      //                   title: '03/14/2021',
      //                 },
      //                 {
      //                   title: '03/21/2021',
      //                 },
      //                 {
      //                   title: '03/28/2021',
      //                 }
      //               ]
      //             },
      //           ]
      //         },
      //         {
      //           title: 'Q2 FY21',
      //           monthList: [
      //             {
      //               title: 'April FY21',

      //               weekList: [
      //                 {
      //                   title: '04/04/2021',
      //                 },
      //                 {
      //                   title: '04/11/2021',
      //                 },
      //                 {
      //                   title: '04/18/2021',
      //                 },
      //                 {
      //                   title: '04/25/2021',
      //                 }
      //               ]
      //             },
      //             {
      //               title: 'May FY21',
      //               weekList: [
      //                 {
      //                   title: '05/02/2021'
      //                 },
      //                 {
      //                   title: '05/09/2021',
      //                 },
      //                 {
      //                   title: '05/16/2021',
      //                 },
      //                 {
      //                   title: '05/23/2021',
      //                 }
      //               ]
      //             },
      //             { //May be disturbed
      //               title: 'June FY21',

      //               weekList: [
      //                 {
      //                   title: '05/30/2021',
      //                 },
      //                 {
      //                   title: '06/06/2021',
      //                 },
      //                 {
      //                   title: '06/13/2021',
      //                 },
      //                 {
      //                   title: '06/20/2021',
      //                 },
      //                 {
      //                   title: '06/27/2021',
      //                 }
      //               ]
      //             },
      //           ]
      //         },
      //       ]
      //     },
      //     {
      //       title: 'H2 FY21',
      //       quarterList: [
      //         {
      //           title: 'Q3',

      //           monthList: [
      //             {
      //               title: 'July FY21',

      //               weekList: [
      //                 {
      //                   title: '07/04/2021',
      //                 },
      //                 {
      //                   title: '07/11/2021',
      //                 },
      //                 {
      //                   title: '07/18/2021',
      //                 },
      //                 {
      //                   title: '07/25/2021',
      //                 }
      //               ]
      //             },
      //             {
      //               title: 'August FY21',
      //               weekList: [

      //                 {
      //                   title: '08/01/2021',
      //                 },
      //                 {
      //                   title: '08/08/2021',
      //                 },
      //                 {
      //                   title: '08/15/2021',
      //                 },
      //                 {
      //                   title: '08/22/2021',
      //                 }
      //               ]
      //             },
      //             {
      //               title: 'September FY21',

      //               weekList: [
      //                 {
      //                   title: '08/29/2021',
      //                 },
      //                 {
      //                   title: '09/05/2021',
      //                 },
      //                 {
      //                   title: '09/12/2021',
      //                 },
      //                 {
      //                   title: '09/19/2021',
      //                 },
      //                 {
      //                   title: '09/26/2021',
      //                 }
      //               ]
      //             },
      //           ]
      //         },
      //         {
      //           title: 'Q4 FY21',
      //           monthList: [
      //             {
      //               title: 'October FY21',
      //               weekList: [
      //                 {
      //                   title: '10/03/2021',
      //                 },
      //                 {
      //                   title: '10/10/2021',
      //                 },
      //                 {
      //                   title: '10/17/2021',
      //                 },
      //                 {
      //                   title: '10/24/2021',
      //                 }
      //               ]
      //             },
      //             {
      //               title: 'November FY21',
      //               weekList: [
      //                 {
      //                   title: '10/31/2021',
      //                 },
      //                 {
      //                   title: '11/07/2021',
      //                 },
      //                 {
      //                   title: '11/14/2021',
      //                 },
      //                 {
      //                   title: '11/21/2021',
      //                 }
      //               ]
      //             },
      //             {
      //               title: 'December FY21',
      //               weekList: [
      //                 {
      //                   title: '11/28/2021',
      //                 },
      //                 {
      //                   title: '12/05/2021',
      //                 },
      //                 {
      //                   title: '12/12/2021',
      //                 },
      //                 {
      //                   title: '12/19/2021',
      //                 },
      //                 {
      //                   title: '12/26/2021',
      //                 }

      //               ]
      //             },
      //           ]
      //         },
      //       ]
      //     }
      //   ]
      // },
    ];
    this.dropdownSettingsSingle = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.customerList = (this.customerList as any).map(customer => ({
      item_id: customer,
      item_text: customer
    }));
    this.itemList = (this.itemList as any).map(item => ({
      item_id: item,
      item_text: item
    }));
    this.versionList.push(
      'Commit',
      'V1',
      'V2',
      'V3'
    );
    for (let index = 0; index < 12; index++) {
      const date = new Date(2009, index, 10);  // 2009-11-10
      const month = date.toLocaleString('default', { month: 'long' });
      const shortMonth = date.toLocaleString('default', { month: 'long' });
      this.monthList.push(
        {
          item_id: `${shortMonth} FY21`, item_text: `${month} FY21`
        });
    }
    this.monthList.unshift({ item_id: `December FY20`, item_text: `December FY20` });
    this.monthList.unshift({ item_id: `November FY20`, item_text: `November FY20` });
    this.customerList = (this.customerList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.itemList = (this.itemList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.searchCustomer.setValue('');
    this.searchItem.setValue('');
    this.roundWeekValues();
    this.yearListTemp = JSON.parse(JSON.stringify(this.yearList));
    this.yearListForFilter = JSON.parse(JSON.stringify(this.yearList));
  }
  public roundWeekValues = () => {
    this.yearList.forEach((year: PhysicalYear) => {
      this.convertValues(year);
      year.halfList.forEach((half: HalfYear) => {
        this.convertValues(half);
        half.quarterList.forEach((quarter: Quarter) => {
          this.convertValues(quarter);
          quarter.monthList.forEach((month: Month) => {
            this.convertValues(month);
            month.weekList.forEach((week: Week) => {
              this.convertValues(week);
            });
          })
        })
      });
    })
  }
  public convertValues = (week: Week) => {
    Object.keys(week.ForecastMethod).forEach(key => {
      if (!isNaN(week.ForecastMethod[key]) && week.ForecastMethod[key])
        week.ForecastMethod[key] = Number.isInteger(week.ForecastMethod[key]) ? week.ForecastMethod[key] : Number(parseFloat(week.ForecastMethod[key]).toFixed(0))
    });
    Object.keys(week.ForecastMethodVarianceActual).forEach(key => {
      if (!isNaN(week.ForecastMethodVarianceActual[key]) && week.ForecastMethodVarianceActual[key])
        week.ForecastMethodVarianceActual[key] = Number.isInteger(week.ForecastMethodVarianceActual[key]) ? week.ForecastMethodVarianceActual[key] : Number(parseFloat(week.ForecastMethodVarianceActual[key]).toFixed(2))
    });
    Object.keys(week.ForecastMethodUnitVarianceActual).forEach(key => {
      if (!isNaN(week.ForecastMethodUnitVarianceActual[key]) && week.ForecastMethodUnitVarianceActual[key])
        week.ForecastMethodUnitVarianceActual[key] = Number.isInteger(week.ForecastMethodUnitVarianceActual[key]) ? week.ForecastMethodUnitVarianceActual[key] : Number(parseFloat(week.ForecastMethodUnitVarianceActual[key]).toFixed(2))
    });
  }
  getSeries = (object) => {
    const objList = [];
    Object.keys(object).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        const newObject = {
          name: key,
          value: Number(object[key])
        }
        objList.push(newObject)
      }
    });
    return objList;
  }
  openExcelImportDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.excelImport, { width: '500px', data: data || {} });
  }
  onFilterTextBoxChanged(event) {
    this.gridOptions.api.setQuickFilter(event.target.value);
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
  public onSubmit = () => {
  }
  selectAllSelected(flag: boolean): void {
    if (flag) {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: true }))
    } else {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: false }))
    }
  }
  selectAllGraphSelected(flag: boolean): void {
    if (flag) {
      this.graphChooserList = this.graphChooserList.map(row => ({ ...row, checked: true }))
    } else {
      this.graphChooserList = this.graphChooserList.map(row => ({ ...row, checked: false }))
    }
  }
  public onSave = () => {
    this.dialogRef.close();
    let groups = JSON.parse(JSON.stringify(this.tempGroupList));
    const list = this.chooserList.filter(row => row.checked);
    groups.forEach(group => {
      group.rowspan = list.filter(el => el.tag === group.name).length;
      if (group.name === 'ST Accuracy' && group.rowspan > 0) {
        // group.rowspan = group.rowspan + 1;
      }
    });
    groups = groups.filter(group => group.rowspan);
    this.leftGroupList = groups;
    this.mapListsForMap();
  }
  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }
  exportToExcel = () => {
    this.gridApi.exportDataAsCsv();
  }
  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }
  onSelectAll(items: any) {
  }
  openFullScreen = (id: string) => {
    const domGrid = document.getElementById(id) as any;
    if (domGrid) {
      domGrid.webkitRequestFullscreen();
    }
  }
  applyGraph(totalCalculatedList) {
    const data = {
      chart: {
        caption: "",
        yaxisname: "",
        subcaption: "",
        showhovereffect: "1",
        lineThickness: "4",
        "width": "100%",
        "height": "150px",
        numbersuffix: "",
        "paletteColors": "#8D009D,#F8486E, #1C9FAD, #2480D3",
        drawcrossline: "1",
        plottooltext: "$seriesName <b>$dataValue</b> ",
        theme: "fusion"
      },
      categories: [
        {
          category: this.getLabels()
        }
      ],
      dataset: totalCalculatedList.map(item => ({ seriesname: this.chooserList.find(el => el.key === Object.keys(item)[0]).name, data: item[Object.keys(item)[0]].map(row => ({ value: row[Object.keys(row)[0]] })) }))
    };
    this.dataSource = data as any;
  }
  public getLabels = () => {
    // const el = totalCalculatedList[0];
    const list = [];
    const dateList = this.graphList.map(row => ({ label: row.title }));
    return dateList;
    // Object.keys(el).forEach(key => {
    //   const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
    //   if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
    //     list.push({ label: this.getKeyValue(key) });
    //   }
    //   if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
    //     const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
    //     if (flag) {
    //       list.push({ label: this.getKeyValue(key) });
    //     }
    //   }
    // });
    // return list;
  }
  getKeyValue(key) {
    const list = [
      { key: 'janw1', value: '01/05/2020' },
      { key: 'janw2', value: '01/12/2020' },
      { key: 'janw3', value: '01/19/2020' },
      { key: 'janw4', value: '01/26/2020' },
      { key: 'ttlJanuary', value: 'Total January' },
      { key: 'febw1', value: '02/02/2020' },
      { key: 'febw2', value: '02/09/2020' },
      { key: 'febw3', value: '02/16/2020' },
      { key: 'febw4', value: '02/23/2020' },
      { key: 'ttlFebruary', value: 'Total February' },
      { key: 'marchw1', value: '03/01/2020' },
      { key: 'marchw2', value: '03/08/2020' },
      { key: 'marchw3', value: '03/15/2020' },
      { key: 'marchw4', value: '03/22/2020' },
      { key: 'marchw5', value: '03/29/2020' },
      { key: 'ttlMarch', value: 'Total March' },
      { key: 'q1', value: 'Q1' },
      { key: 'aprilw1', value: '04/05/2020' },
      { key: 'aprilw2', value: '04/12/2020' },
      { key: 'aprilw3', value: '04/19/2020' },
      { key: 'aprilw4', value: '04/26/2020' },
      { key: 'ttlApril', value: 'Total April' },
      { key: 'mayw1', value: '05/03/2020' },
      { key: 'mayw2', value: '05/10/2020' },
      { key: 'mayw3', value: '05/17/2020' },
      { key: 'mayw4', value: '05/24/2020' },
      { key: 'ttlMay', value: 'Total May' },
      { key: 'junew1', value: '05/31/2020' },
      { key: 'junew2', value: '06/07/2020' },
      { key: 'junew3', value: '06/14/2020' },
      { key: 'junew4', value: '06/21/2020' },
      { key: 'junew5', value: '06/28/2020' },
      { key: 'ttlJune', value: 'Total June' },
      { key: 'q2', value: 'Q2' },
      { key: 'julyw1', value: '07/05/2020' },
      { key: 'julyw2', value: '07/12/2020' },
      { key: 'julyw3', value: '07/19/2020' },
      { key: 'julyw4', value: '07/26/2020' },
      { key: 'ttlJuly', value: 'Total July' },
      { key: 'augw1', value: '08/02/2020' },
      { key: 'augw2', value: '08/09/2020' },
      { key: 'augw3', value: '08/16/2020' },
      { key: 'augw4', value: '08/23/2020' },
      { key: 'ttlAugust', value: 'Total August' },
      { key: 'sepw1', value: '09/30/2020' },
      { key: 'sepw2', value: '09/06/2020' },
      { key: 'sepw3', value: '09/13/2020' },
      { key: 'sepw4', value: '09/20/2020' },
      { key: 'sepw5', value: '09/27/2020' },
      { key: 'ttlSeptember', value: 'Total September' },
      { key: 'q3', value: 'Q3' },
      { key: 'octw1', value: '10/04/2020' },
      { key: 'octw2', value: '10/11/2020' },
      { key: 'octw3', value: '10/18/2020' },
      { key: 'octw4', value: '10/25/2020' },
      { key: 'ttlOctober', value: 'Total October' },
      { key: 'novw1', value: '11/01/2020' },
      { key: 'novw2', value: '11/08/2020' },
      { key: 'novw3', value: '11/15/2020' },
      { key: 'novw4', value: '11/22/2020' },
      { key: 'ttlNovember', value: 'Total November' },
      { key: 'novw5', value: '11/29/2020' },
      { key: 'decw1', value: '12/06/2020' },
      { key: 'decw2', value: '12/13/2020' },
      { key: 'decw3', value: '12/20/2020' },
      { key: 'decw4', value: '12/27/2020' },
      { key: 'ttlDecember', value: 'Total December' },
      { key: 'q4', value: 'Q4' },
      { key: 'totalYear', value: 'Total Year' },
    ];
    return list.find(item => item.key === key) ? list.find(item => item.key === key).value : '';
  }
  applyFormula = (model: Week, field: string) => {
    if (field === 'DPManualFcstAdjustment') {
    }
  }
  DPManualFcstAdjustmentUpdated = (model: Week) => {
    this.mapListsForMap();
  }
  DPPromoUnitsUpdated = (model: Week) => {
    this.mapListsForMap();
  }

  getWidth = () => {
    return window.screen.width - 550 + 'px';
  }
  percentToInt(value) {
    if (typeof value === 'string') {
      const x = value.split('%')[1];
      if (x) {
        return parseFloat(x.replace(/,/g, ''));
      } else {
        return parseFloat(value);
      }
    }
    return value / 100;
  }
  filterListByMonth = (list) => {
    if (list) {
      this.timeframeSelectedList = list;
    }
    if (this.timeframeSelectedList.length > 0) {
      this.yearListForFilter = JSON.parse(JSON.stringify(this.yearListTemp));
      const selectedList = this.timeframeSelectedList.map(res => res.item_id);
      this.yearList = this.yearListForFilter.filter(year => {
        year.halfList = year.halfList.filter(half => {
          half.quarterList = half.quarterList.filter(quarter => {
            quarter.monthList = quarter.monthList.filter(month => selectedList.includes(month.title));
            return quarter.monthList.find(month => selectedList.includes(month.title))
          });
          return half.quarterList.length > 0;
        });
        return year.halfList.length > 0;
      });
    }
    this.mapListsForMap();
  }
  setBackground = (value) => {
    setTimeout(() => {
      this.chooserList.forEach(row => {
        if (document.getElementById(row.key)) {
          let isDisabled = (document.getElementById(row.key) as any).disabled;
          if (isDisabled) {
            document.getElementById(row.key).parentElement.style.background = '#eee';
          } else {
            document.getElementById(row.key).parentElement.style.background = '#fff';
          }
        }
      });
    }, 10);
  }
  public mapListsForMap = () => {
    this.graphList = [];
    const chartList = []
    this.graphChooserList.forEach(row => {
      if (row.checked) {
        let obj = {};
        obj[row.key] = [];
        chartList.push(obj);
      }
    });
    this.roundWeekValues();
    this.yearList.forEach(year => {
      year.halfList.forEach(half => {
        half.quarterList.forEach(quarter => {
          quarter.monthList.forEach(month => {
            month.weekList.forEach(week => {
              let object = {
                ...week.ForecastMethod,
                ...week.ForecastMethodVarianceActual,
                ...week.ForecastMethodUnitVarianceActual,
                title: week.title
              }
              this.graphList.push(object);
              chartList.forEach((el) => {
                let obj = {};
                obj[week.title] = object[Object.keys(el)[0]];
                el[Object.keys(el)[0]].push(obj);
              })
            });
          })
        })
      })
    });
    this.applyGraph(chartList);
  }
  checkIfInList = (key: string) => {
    return this.chooserList.find(el => el.key === key && el.checked);
  }
  collapseYear = (year: PhysicalYear) => {
    year.show = !year.show;
    if (year.show) {
      const object = {
        ...year.ForecastMethod,
        ...year.ForecastMethodVarianceActual,
        ...year.ForecastMethodUnitVarianceActual,
      };
      Object.keys(object).forEach(key => {
        if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
          year.ForecastMethod[key] = 0;
          year.ForecastMethodVarianceActual[key] = 0;
          year.ForecastMethodUnitVarianceActual[key] = 0;
        }
      });
      year.halfList.forEach(half => {
        half.quarterList.forEach(quarter => {
          quarter.monthList.forEach(month => {
            month.weekList.forEach(week => {
              Object.keys(object).forEach(key => {
                if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
                  year.ForecastMethod[key] += +week.ForecastMethod[key];
                  year.ForecastMethodVarianceActual[key] += +week.ForecastMethodVarianceActual[key];
                  year.ForecastMethodUnitVarianceActual[key] += +week.ForecastMethodUnitVarianceActual[key];
                }
              });
            });
          })
        })
      })
    }
    this.roundWeekValues();
  }
  collapseHalf = (half: HalfYear) => {
    half.show = !half.show;
    if (half.show) {
      const object = {
        ...half.ForecastMethod,
        ...half.ForecastMethodVarianceActual,
        ...half.ForecastMethodUnitVarianceActual
      };
      Object.keys(object).forEach(key => {
        if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
          half.ForecastMethod[key] = 0;
          half.ForecastMethodVarianceActual[key] = 0;
          half.ForecastMethodUnitVarianceActual[key] = 0;
        }
      });
      half.quarterList.forEach(quarter => {
        quarter.monthList.forEach(month => {
          month.weekList.forEach(week => {
            Object.keys(object).forEach(key => {
              if (half && week) {
                if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
                  half.ForecastMethod[key] += +week.ForecastMethod[key];
                  half.ForecastMethodVarianceActual[key] += +week.ForecastMethodVarianceActual[key];
                  half.ForecastMethodUnitVarianceActual[key] += +week.ForecastMethodUnitVarianceActual[key];
                }

              }

            });
          });
        })
      })
    }
    this.roundWeekValues();
  }
  collapseQuarter = (quarter: Quarter) => {
    quarter.show = !quarter.show;
    if (quarter.show) {
      const object = {
        ...quarter.ForecastMethod,
        ...quarter.ForecastMethodVarianceActual,
        ...quarter.ForecastMethodUnitVarianceActual
      };
      Object.keys(object).forEach(key => {
        if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
          quarter.ForecastMethod[key] = 0;
          quarter.ForecastMethodVarianceActual[key] = 0;
          quarter.ForecastMethodUnitVarianceActual[key] = 0;
        }
      });
      quarter.monthList.forEach(month => {
        month.weekList.forEach(week => {
          Object.keys(object).forEach(key => {
            if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
              quarter.ForecastMethod[key] += +week.ForecastMethod[key];
              quarter.ForecastMethodVarianceActual[key] += +week.ForecastMethodVarianceActual[key];
              quarter.ForecastMethodUnitVarianceActual[key] += +week.ForecastMethodUnitVarianceActual[key];
            }

          });
        });
      });
    }
    this.roundWeekValues();
  }
  collapseMonth = (month: Month) => {
    month.show = !month.show;
    if (month.show) {
      const object = {
        ...month.ForecastMethod,
        ...month.ForecastMethodVarianceActual,
        ...month.ForecastMethodUnitVarianceActual
      };
      Object.keys(object).forEach(key => {
        if (!(key.endsWith('Comments') || key.endsWith('comments'))) {

          month.ForecastMethod[key] = 0;
          month.ForecastMethodVarianceActual[key] = 0;
          month.ForecastMethodUnitVarianceActual[key] = 0;
        }
      });
      month.weekList.forEach(week => {
        Object.keys(object).forEach(key => {
          if (!(key.endsWith('Comments') || key.endsWith('comments'))) {
            month.ForecastMethod[key] += +week.ForecastMethod[key];
            month.ForecastMethodVarianceActual[key] += +week.ForecastMethodVarianceActual[key];
            month.ForecastMethodUnitVarianceActual[key] += +week.ForecastMethodUnitVarianceActual[key];
          }
        });
      });
    }
    this.roundWeekValues();
  }
  getObject = (year, month, quarter, half) => {
    if (year.show) {
      return year;
    }
    if (half.show) {
      return half;
    }
    if (quarter.show) {
      return quarter;
    }
    if (month.show) {
      return month;
    }
  }
  checkIfToShow = (index) => {
    if (index > -1 && (index + 1) < this.chooserList.length) {
      return this.chooserList[index].tag !== this.chooserList[index + 1].tag
    }
  }
  getName = () => {
    if (this.checklistSelection.selected.length > 0) {
      return this.checklistSelection.selected[0].item;
    } else {
      return 'Select Product';
    }
  }
  getHalfObject = (value) => {
    console.log(value)
  }
  updateDPBaseLineValues = (week: Week) => {
    week.ForecastMethodVarianceActual.DPBaselineSTvartoActual = (week.ForecastMethod.DPBaselineSTFcst - week.ForecastMethod.ActualSales) / week.ForecastMethod.ActualSales;
    week.ForecastMethodUnitVarianceActual.DPBaselineSTtoActualUnits = (week.ForecastMethod.DPBaselineSTFcst - week.ForecastMethod.ActualSales);
  }
  updateCOBaseLineValues = (week: Week) => {
    week.ForecastMethodVarianceActual.COBaselineSTvartoActual = (week.ForecastMethod.COBaselineSTForecast - week.ForecastMethod.ActualSales) / week.ForecastMethod.ActualSales;
    week.ForecastMethodUnitVarianceActual.COBaselineSTvartoActualUnits = (week.ForecastMethod.COBaselineSTForecast - week.ForecastMethod.ActualSales);
  }
  filterListByMethod = (value) => {
    if (value !== 'CurrentAlgoBaselineSTForecast') {
      this.yearList.forEach(year => {
        year.halfList.forEach(half => {
          half.quarterList.forEach(quarter => {
            quarter.monthList.forEach(month => {
              month.weekList.forEach(week => {
                week.ForecastMethod.CurrentAlgoBaselineSTForecast = week.ForecastMethod[value];
              })
            })
          })
        })
      });
    } else {
      this.yearList = JSON.parse(JSON.stringify(this.yearListTemp));
      this.roundWeekValues();
    }
  }
}
